
export default [
    {
        id: 0,
        category: "Up to 50% off | Baby products & toys | Amazon Brands",
        subCategory: [
            {
                title: "Diapers, wipes & more",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_diaper_186x116._SY116_CB620365328_.jpg"
            },
            {
                title: "Soft toys",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_Teddy_186x116._SY116_CB620365328_.jpg"
            },
            {
                title: "Indoor games",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_indoor_game_186x116._SY116_CB620365328_.jpg"
            },
            {
                title: "Outdoor & more",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_rideon_372X232._SY116_CB620365328_.jpg"
            }
        ]
    },
    {
        id: 1,
        category: "Up to 60% off | Styles for men",
        subCategory: [
            {
                title: "Diapers, wipes & more",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img22/Fashion/Gateway/BAU/BTF-Refresh/May/PF_MF/MF-1-186-116._SY116_CB636110853_.jpg"
            },
            {
                title: "Soft toys",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img22/Fashion/Gateway/BAU/BTF-Refresh/May/PF_MF/MF-2-186-116._SY116_CB636110853_.jpg"
            },
            {
                title: "Indoor games",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img22/Fashion/Gateway/BAU/BTF-Refresh/May/PF_MF/MF-3-186-116._SY116_CB636110853_.jpg"
            },
            {
                title: "Outdoor & more",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img22/Fashion/Gateway/BAU/BTF-Refresh/May/PF_MF/MF-4-186-116._SY116_CB636110853_.jpg"
            }
        ]
    },
    {
        id: 2,
        category: "Up to 50% off | Baby products & toys | Amazon Brands",
        subCategory: [
            {
                title: "Diapers, wipes & more",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_diaper_186x116._SY116_CB620365328_.jpg"
            },
            {
                title: "Soft toys",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_Teddy_186x116._SY116_CB620365328_.jpg"
            },
            {
                title: "Indoor games",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_indoor_game_186x116._SY116_CB620365328_.jpg"
            },
            {
                title: "Outdoor & more",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_rideon_372X232._SY116_CB620365328_.jpg"
            }
        ]
    },
    {
        id: 3,
        category: "Up to 50% off | Baby products & toys | Amazon Brands",
        subCategory: [
            {
                title: "Diapers, wipes & more",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_diaper_186x116._SY116_CB620365328_.jpg"
            },
            {
                title: "Soft toys",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_Teddy_186x116._SY116_CB620365328_.jpg"
            },
            {
                title: "Indoor games",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_indoor_game_186x116._SY116_CB620365328_.jpg"
            },
            {
                title: "Outdoor & more",
                url: "https://images-eu.ssl-images-amazon.com/images/G/31/img21/AmazonBrands/GW_CPB_/QC_CC/PC_QC_rideon_372X232._SY116_CB620365328_.jpg"
            }
        ]
    }
]